const SECS_IN_ONE_HOUR = 3600;
const SECS_IN_ONE_DAY = 86400;
const MS_IN_ONE_HOUR = 3600000;
const MS_IN_ONE_DAY = 86400000;
const SECS_IN_ONE_MIN = 60;
const MS_IN_ONE_MIN = 60000;
const MAX_REST = 25;

const CONSTANTS = {
    SECS_IN_ONE_HOUR,
    SECS_IN_ONE_DAY,
    MS_IN_ONE_HOUR,
    MS_IN_ONE_DAY,
    MAX_REST,
    SECS_IN_ONE_MIN,
    MS_IN_ONE_MIN
};

export default CONSTANTS;
